import { createContext } from 'react';

export const FontSizeContext = createContext();